"use client";

import React from "react";

//Style
import * as S from "./styles";
import { HeaderContentPageProps } from "@/types";

const HeaderContentPage: React.FC<HeaderContentPageProps> = ({
  className,
  PageTitle,
  children,
  Description,
}) => {
  return (
    <S.Box className={className}>
      <S.FirstBox>
        <S.Title>{PageTitle}</S.Title>
        <S.Description>{Description}</S.Description>
      </S.FirstBox>
      {children}
    </S.Box>
  );
};

export default HeaderContentPage;
